<template>
  <zm-tooltip placement="top">
    <div slot="content" v-html="contentText"></div>
    <button class="button-icon" :aria-label="title ? `Learn More about ${title}` : 'Help Tooltip icon'" tabindex="0">
      <span class="sr-only" id="tooltip-icon" aria-hidden="true">Help Tooltip icon</span>
      <i class="zm-icon-info-outline zm-icon-info-outline-developer" @mouseover="handleTooltipOpen"></i>
    </button>
  </zm-tooltip>
</template>

<script>
export default {
  name: 'ToolTips',
  props: {
    contentText: String,
    title: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleTooltipOpen(evt) {
      this.$emit('openTooltip', evt);
    }
  }
};
</script>

<style lang="scss" scoped>
  .zm-icon-info-outline {
    color: #0B5CFF;
  }
  .button-icon {
    background: transparent;
    border: 0;
    padding: 1px 4px;
  }
</style>
